import React from "react";
import PropTypes from "prop-types";
import CalendarComponent from "./component/CalendarComponent";

const DashboardCalendar = ({ events, canEdit, onEventClick, onAddEvent }) => {
  return (
    <div data-tour="calendar-events">
      <CalendarComponent
        events={events}
        canEdit={canEdit}
        onEventClick={onEventClick}
        onAddEvent={onAddEvent}
        title="ACADEMIC CALENDAR"
        subtitle="A.Y. 2025–2026"
        showManagement
      />
    </div>
  );
};

DashboardCalendar.propTypes = {
  events: PropTypes.array.isRequired,
  canEdit: PropTypes.bool.isRequired,
  onEventClick: PropTypes.func.isRequired,
  onAddEvent: PropTypes.func.isRequired,
};

export default DashboardCalendar;
